/* istanbul ignore file */
import React, { useState } from 'react';
import { Box, Collapse } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import MoreIcon from '@mui/icons-material/ExpandMoreOutlined';
import LessIcon from '@mui/icons-material/ExpandLessOutlined';
import { useUiTheme } from 'framework/uiTheme';

interface BreadcrumbsWithMenuProps {
  breadcrumbs?: React.ReactNode;
  menu?: React.ReactNode;
}

const BreadcrumbsWithMenu = ({ breadcrumbs, menu = null }: BreadcrumbsWithMenuProps) => {
  const [menuIsOpened, setMenuIsOpened] = useState(false);
  const { Button: ThemedButton = Button } = useUiTheme();

  return (
    <>
      <Box display="flex" alignItems="center">
        {breadcrumbs && <Box mb={3}>{breadcrumbs}</Box>}
        {menu && (
          <ThemedButton
            size="small"
            sx={{
              display: { xs: 'inline-flex', sm: 'none' },
              ml: '8px',
              mt: '-28px',
              minWidth: '10px',
              p: '3px !important',
            }}
            variant="outlined"
            onClick={() => setMenuIsOpened(!menuIsOpened)}
          >
            {menuIsOpened ? <LessIcon /> : <MoreIcon />}
          </ThemedButton>
        )}
      </Box>

      <Box
        sx={{
          mb: '25px',
          ml: { xs: -2, md: -2.25 },
          mr: { xs: -2, md: 4 },
          flexShrink: 0,
          width: { md: '215px' },
          display: { xs: 'block', sm: 'none' },
          ...(!menuIsOpened ? { mb: '0 !important' } : {}),
        }}
      >
        <Collapse in={menuIsOpened}>{menu}</Collapse>
      </Box>
    </>
  );
};

export default BreadcrumbsWithMenu;
